import { Box, Heading, VStack } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getUserDetails } from '../stores/slices/user/userActions';
import AccountDetails from '../components/Profile/AccountDetails';
import Password from '../components/Profile/Password';
import ProfileImage from '../components/Profile/ProfileImage';

const Profile = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getUserDetails());
    //eslint-disable-next-line
  }, []);

  return (
    <VStack px={{ base: 4, md: 10 }} py={8} spacing={{ base: 2, md: 4 }}>
      <Box w={'full'}>
        <Heading>Profile</Heading>
      </Box>
      <ProfileImage />
      <AccountDetails />
      <Password />
    </VStack>
  );
};

export default Profile;
